/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Estes_Booking_Failed_GenericInputs */

const en_orders_estes_booking_failed_generic = /** @type {(inputs: Orders_Estes_Booking_Failed_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to book LTL shipments`)
};

const es_orders_estes_booking_failed_generic = /** @type {(inputs: Orders_Estes_Booking_Failed_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron reservar envios LTL`)
};

/**
* | output |
* | --- |
* | "Failed to book LTL shipments" |
*
* @param {Orders_Estes_Booking_Failed_GenericInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_estes_booking_failed_generic = /** @type {((inputs?: Orders_Estes_Booking_Failed_GenericInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Estes_Booking_Failed_GenericInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_estes_booking_failed_generic(inputs)
	return es_orders_estes_booking_failed_generic(inputs)
});